// extracted by mini-css-extract-plugin
export default {"navItem":"nav_item_navItem__9MnB2","link":"nav_item_link__Mmqz8"};